import apiClient from '@/api/apiClient'

export const getContact = (accountId, contactId) =>
  apiClient.get(`api/v1/accounts/${accountId}/contacts/${contactId}`)
